import React from 'react';

const Account = () => (
  <path d="M16 4c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6-6-2.6863-6-6 2.6863-6 6-6zm0 2c-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4 2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4zM8.479 18.682L10 18.4518a40.0782 40.0782 0 0 1 12 0l1.521.2304c2.58.3909 4.479 2.51 4.479 4.9982V26C28 27.1045 27.0598 28 25.9 28H6.1C4.9402 28 4 27.1045 4 25.9999v-2.3196c0-2.4882 1.899-4.6073 4.479-4.9982zM6 26h20v-2.0475c0-1.517-.9188-2.8089-2.167-3.0472l-1.69-.3226c-4.0697-.777-8.2163-.777-12.286 0l-1.69.3226C6.9189 21.1436 6 22.4356 6 23.9525V26z" />
);

export default Account;
